import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrProses = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrProsesData:{
            Prosesadi: "",
            Prosesgirdiler: "",
            Prosesciktilar: "",
            Proseskaynaklar: "",
            Deleted: false,
          },
        FormDataType:{ 
          Prosesadi:{FieldName:"Prosesadi",Field:"textarea",FieldTitle:this.$t('StrProses.AddEdit.Prosesadi')},
          Prosesgirdiler:{FieldName:"Prosesgirdiler",Field:"textarea",FieldTitle:this.$t('StrProses.AddEdit.Prosesgirdiler')},
          Prosesciktilar:{FieldName:"Prosesciktilar",Field:"textarea",FieldTitle:this.$t('StrProses.AddEdit.Prosesciktilar')},
          Proseskaynaklar:{FieldName:"Proseskaynaklar",Field:"textarea",FieldTitle:this.$t('StrProses.AddEdit.Proseskaynaklar')},
        }   
      }
    },
    validations:{ 
        FormData: {
            Prosesadi: { required },
            Prosesgirdiler: {},
            Prosesciktilar: {},
            Proseskaynaklar:{},
        } 
    },


    created(){ 


    
      
    }

}
export default StrProses